export default {
  processingId: null,
  active: [],
  matches: [],
  stat: {
    count: {
      all: 0,
      left: 0
    },
    time: {
      max: 0,
      min: 0,
      near: 0
    }
  }
};
